import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Cta from 'component/Layout/Cta';

import classNames from 'classnames';

import {
    useChangedFilterCount,
    useResetChangedFilterList,
} from 'hooks/form/useChangedFilterList';
import { useSync } from 'hooks/form/useSync';

import styles from './Apply.module.scss';

interface ApplyProps {
    customClassList?: {
        Content?: string;
        ButtonWrapper?: string;
        Button?: string;
    };
}

const Apply = ({ customClassList }: ApplyProps) => {
    const { t } = useTranslation();
    const count = useChangedFilterCount();
    const resetChangedFilterList = useResetChangedFilterList();
    const { syncSearchWithFilterStore } = useSync();
    const submit = useCallback(() => {
        resetChangedFilterList();
        syncSearchWithFilterStore();
    }, [resetChangedFilterList, syncSearchWithFilterStore]);

    if (!count) {
        return null;
    }

    return (
        <div className={classNames(styles.Apply, customClassList?.Content)}>
            <div
                className={classNames(
                    styles.ButtonWrapper,
                    customClassList?.ButtonWrapper
                )}
            >
                <Cta
                    onClick={submit}
                    customClassList={{
                        Cta: classNames(styles.Button, customClassList?.Button),
                    }}
                >
                    {t('TRANS-apply-filter', { count: count })}
                </Cta>
            </div>
        </div>
    );
};

export default Apply;
